import {
  Component,
  OnInit,
  Inject,
  ChangeDetectionStrategy,
} from "@angular/core";
import { CoreService } from "src/app/helpers/services/core.service";
import { ToastrService } from "ngx-toastr";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "loyaltic-coming-soon",
  templateUrl: "./coming-soon.component.html",
  styleUrls: ["./coming-soon.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ComingSoonComponent implements OnInit {
  UserName = "";
  adminLock = true;
  culture = "";
  comingsoonlclKey = "comingsoon-intro";
  appbrand = "";
  constructor(
    @Inject("ImagePath") public ImagePath: any,
    private coreService: CoreService,
    private toast: ToastrService,
    public translate: TranslateService,
  ) {
    this.appbrand = localStorage.getItem("brand") || "";
  }

  ngOnInit() {
    this.comingsoonlclKey =
      this.appbrand !== "" && this.appbrand === "aeg"
        ? this.comingsoonlclKey + "-" + this.appbrand
        : this.comingsoonlclKey;
        console.log('comingsoonlclKey', this.comingsoonlclKey);
    this.culture = this.translate.getDefaultLang();
  }

  onSubmit(form: any) {
    this.coreService.signUp(this.UserName).then((response: any) => {
      form.submitted = false;
      this.UserName = "";
      const messageKey = response.messageKey;
      this.toast.success(
        this.translate.instant("" + messageKey),
        this.translate.instant("success"),
      );
    });
  }
}
